import "./_line.scss";

import {CSSProperties} from "react";
import classNames from "classnames";

export interface LineProps {
  bgColor?: string;
  margin?: number;
  size?: number;
  customClassName?: string;
}

function Line({
  bgColor = "var(--border-default)",
  /* eslint-disable-next-line no-magic-numbers */
  margin = 16,
  size = 1,
  customClassName
}: LineProps) {
  return (
    <span
      className={classNames("line", customClassName)}
      style={
        {
          "--line-size": `${size}px`,
          "--line-margin": `${margin}px`,
          "--line-bg-color": bgColor
        } as CSSProperties
      }
    />
  );
}

export default Line;
